import type { ReactElement } from 'react';
import type { IconRenderProps } from '../types';

export function DownloadIcon({
	width = 18,
	height,
	color = 'currentColor',
	opacity,
	style,
	...rest
}: IconRenderProps): ReactElement {
	const h = height ?? Math.round((width ?? 18) * (16 / 18));
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={h}
			viewBox="0 0 18 16"
			fill="none"
			aria-hidden="true"
			style={{ display: 'block', opacity, ...style }}
			{...rest}
		>
			<path
				d="M4.81848 8.48426C4.56406 8.21424 4.57185 7.79338 4.83579 7.53194C5.09887 7.27136 5.52378 7.26365 5.79723 7.51566L8.30762 10.0022V0.685735C8.30762 0.306862 8.61742 0 8.99993 0C9.38243 0 9.69223 0.306862 9.69223 0.685735V10.0022L12.2026 7.51566C12.4761 7.26365 12.901 7.27137 13.1641 7.53194C13.428 7.79338 13.4358 8.21424 13.1814 8.48426L9.48871 12.1419C9.21871 12.4093 8.78082 12.4093 8.51082 12.1419L4.81848 8.48426ZM17.3077 10.0572C16.9278 10.0623 16.6206 10.3666 16.6154 10.7429V14.4005C16.6154 14.4605 16.5912 14.5188 16.5479 14.5617C16.5046 14.6045 16.4458 14.6285 16.3843 14.6285H1.61568C1.4876 14.6285 1.38461 14.5265 1.38461 14.4005V10.7429C1.38461 10.364 1.07481 10.0572 0.692306 10.0572C0.309802 10.0572 0 10.364 0 10.7429V14.4005C0.0051923 15.2817 0.725186 15.9957 1.61568 16H16.3843C17.2748 15.9957 17.9948 15.2817 18 14.4005V10.7429C17.9948 10.3666 17.6876 10.0623 17.3077 10.0572Z"
				fill={color}
			/>
		</svg>
	);
}
